import { yup } from '../../../shared/utils/yup';
import { IPortalTag } from '../../tag/types';

const yupTag: Partial<Record<keyof IPortalTag, yup.BaseSchema>> = {};

export const tagShema = yup.object({}).shape(yupTag);
